var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactBook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 442 442",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.4 221c0 9.391-7.609 17-17 17h-34c-9.391 0-17-7.609-17-17s7.609-17 17-17h34c9.392 0 17 7.609 17 17zm0-108.8c0-9.391-7.609-17-17-17h-34c-9.391 0-17 7.609-17 17s7.609 17 17 17h34c9.392 0 17-7.609 17-17zm0 217.601c0-9.393-7.609-17-17-17h-34c-9.391 0-17 7.607-17 17 0 9.391 7.609 17 17 17h34c9.392 0 17-7.61 17-17zM404.6 54.4v333.2c0 30.043-24.357 54.4-54.398 54.4h-238c-30.042 0-54.4-24.357-54.4-54.4v-27.2h30.6c16.871 0 30.6-13.73 30.6-30.6 0-16.871-13.729-30.602-30.6-30.602H57.8v-47.6h30.6c16.871 0 30.6-13.729 30.6-30.6s-13.729-30.6-30.6-30.6H57.8v-47.6h30.6c16.871 0 30.6-13.729 30.6-30.6 0-16.871-13.729-30.6-30.6-30.6H57.8V54.4C57.8 24.358 82.158 0 112.2 0h238c30.042 0 54.4 24.357 54.4 54.4zM188.945 161.255c0 28.968 23.487 52.455 52.455 52.455 28.969 0 52.455-23.487 52.455-52.455s-23.486-52.456-52.455-52.456c-28.967.001-52.455 23.488-52.455 52.456zM323 289.482c0-32.184-26.098-58.283-58.283-58.283H218.09c-32.191 0-58.29 26.1-58.29 58.283V312.8H323v-23.318z",
    fill: "#10b981",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBook2);
export default __webpack_public_path__ + "static/media/contact-book2.e37042fdc2438fecdf49a61e9aa14339.svg";
export { ForwardRef as ReactComponent };